import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {SignupComponent} from '../../../signup/signup.component';
import {EnvironmentManagerComponent} from '../environment-manager.component';

@Component({
  selector: 'app-environment-creator',
  templateUrl: './environment-creator.component.html',
  styleUrls: ['./environment-creator.component.scss']
})
export class EnvironmentCreatorComponent implements OnInit, OnChanges {

  // @Input() orderOfEnvironments: any;
  @Input() environment: any;
  @Input() databasesPayload: any;
  @Input() showProgressInSummary: any;
  @Input() progressStart6: any;
  @Input() progressOver6: any;
  @Input() databaseSelected: any;
  @Input() reqAPIs: any;
  @Input() expectedHits: any;
  @Input() isOneStepInstallation: any;
  @Input() selectedInstallationType: any;
  @Input() isEnvironmentsCreationComplete: any;
  @Input() partner: any;
  @Input() showDatabase = true;
  @Input() isSignUp = false;
  @Input() showNavigationButtons = true;
  @Input() fromEnvManager = false;

  apiAnticipationInfo = [];
  loading1 = false;

  constructor(private signUpComp: SignupComponent, private envManagerComponent: EnvironmentManagerComponent) { }

  ngOnInit() {
    this.apiAnticipationInfo = [
      {
        title: 'Anticipated API Endpoints',
        content: this.reqAPIs
      },
      {
        title: 'Anticipated Traffic',
        content: this.expectedHits
      }
    ];
  }

  ngOnChanges() {
    this.apiAnticipationInfo = [
      {
        title: 'Anticipated API Endpoints',
        content: this.reqAPIs
      },
      {
        title: 'Anticipated Traffic',
        content: this.expectedHits
      }
    ];
  }

  navigateToConsole(environment) {
    if (this.fromEnvManager === true) {
      let env = '';
      switch (environment) {
        case 'admin':
          env = 'Admin';
          break;
        case 'qa':
          env = 'QA';
          break;
        case 'staging':
          env = 'Staging';
          break;
        case 'dev':
          env = 'Development';
          break;
        default:
          env = environment;
          break;
      }
      if (confirm('You will be logged out from the current environment and redirected to ' + env + ' environment. Do you still want to navigate?')) {
        this.loading1 = true;
        this.envManagerComponent.navigateToDashboardDirectly(environment);
      }
    } else {
      this.signUpComp.navigateToDashboardDirectly(environment);
    }
  }

}
